/**
 * Tipagem dos eventos entregues pelo stream SSE `/v1/notifications/stream` do
 * agency-api. Cada evento SSE usa um destes nomes no campo `event:`
 * (case-sensitive) e o payload JSON correspondente — devem casar 1:1 com o
 * backend. Domínio do portal das imobiliárias: equipe/convites, licenças, seats
 * do plano e suporte.
 */

export interface BrokerJoinedPayload {
  brokerId: string;
  brokerName: string;
}

export interface LicenseActivatedPayload {
  brokerId: string;
  brokerName: string;
}

export interface SeatsLowPayload {
  availableSlots: number;
  planName: string;
}

export interface SupportRepliedPayload {
  ticketId: string;
  ticketCode: string;
  subject: string;
}

export type NotificationEvent =
  | { type: "BrokerJoined"; payload: BrokerJoinedPayload }
  | { type: "LicenseActivated"; payload: LicenseActivatedPayload }
  | { type: "SeatsLow"; payload: SeatsLowPayload }
  | { type: "SupportReplied"; payload: SupportRepliedPayload };

export type NotificationType = NotificationEvent["type"];

export const NOTIFICATION_TYPES: NotificationType[] = [
  "BrokerJoined",
  "LicenseActivated",
  "SeatsLow",
  "SupportReplied",
];

export type ConnectionStatus = "connected" | "reconnecting" | "disconnected";

/** Variante por tipo: garante que `n.type === 'X'` restringe `n.payload`. */
type StoredVariant<T extends NotificationType> = {
  /** UUID local — o backend não devolve um id próprio para a notificação,
   *  apenas o id do recurso referenciado (corretor, chamado, etc). */
  id: string;
  type: T;
  payload: Extract<NotificationEvent, { type: T }>["payload"];
  receivedAt: string;
  read: boolean;
};

export type StoredNotification = {
  [K in NotificationType]: StoredVariant<K>;
}[NotificationType];

/** Rótulos pt-BR por tipo (lado do front; o back só emite o dado bruto). */
export const NOTIFICATION_TYPE_LABEL: Record<NotificationType, string> = {
  BrokerJoined: "Equipe",
  LicenseActivated: "Licença",
  SeatsLow: "Plano",
  SupportReplied: "Suporte",
};
